import * as React from 'react';
import { createPortal } from 'react-dom';

type Options = { targetId?: string };

export const useGlobalNotificationPortal = ({
  targetId = 'global-notifications',
}: Options = {}) => {
  const [el, setEl] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    setEl(typeof document !== 'undefined' ? document.getElementById(targetId) : null);
  }, [targetId]);

  const Portal = React.useMemo(() => {
    const P: React.FC<React.PropsWithChildren> = ({ children }) =>
      el ? createPortal(children, el) : null;
    P.displayName = 'GlobalHeaderPortal';
    return P;
  }, [el]);

  return { Portal, container: el };
};
